// utils/trackHeapUser.ts
export const sendUserDetails = (user: {
  id: string;
  grade: string;
  productType: string;
  schoolName: string;
  schoolId: string;
  entryDate: string;
  studentCount?: number;
  isLC?: boolean;
  studentIdentityId?: string;
}) => {
  if (!window.heap) return;

  window.heap.identify(user.id);

  const userProperties: Record<string, unknown> = {
    grade: user.grade,
    product_type: user.productType,
    school_name: user.schoolName,
    school_id: user.schoolId,
    school_start_date: user.entryDate,
    number_of_students: user.isLC ? user.studentCount : undefined,
    role: user.isLC ? 'Learning Coach' : 'Student'
  };

  if (user.isLC && user.studentIdentityId) {
    userProperties.student_identity_id = user.studentIdentityId;
  }

  window.heap.addUserProperties(userProperties);
};

export const sendFlexDetails = (user: {
  id: string;
  studentFlex?: boolean;
  isLC?: boolean;
  studentIdentityId?: string;
}) => {
  if (!window.heap) return;

  window.heap.identify(user.id);

  const userProperties: Record<string, unknown> = {
    student_flex: user.studentFlex ? true : false
  };

  if (user.isLC && user.studentIdentityId) {
    userProperties.student_identity_id = user.studentIdentityId;
  }

  window.heap.addUserProperties(userProperties);
};